import { createRouteRef } from '@backstage/frontend-plugin-api';

export const agentsRouteRef = createRouteRef();
export const skillsRouteRef = createRouteRef();
